import { provideZoneChangeDetection } from "@angular/core";
import {AppComponent} from './app/app.component';
import {bootstrapApplication} from '@angular/platform-browser';
import {registerLocaleData} from "@angular/common";
import localeIt from "@angular/common/locales/it";
import localeItExtra from "@angular/common/locales/extra/it";
import localeEn from "@angular/common/locales/en";
import localeEnHk from "@angular/common/locales/en-HK";
import {appConfig} from "./app/app.config";

// Hybrid locale: it-IT dates (dd/MM, 24h, Monday start) + en-US number formatting (1,234.56)
const hybridLocale: unknown[] = [...localeIt];
hybridLocale[0] = 'it-US';
hybridLocale[13] = localeEn[13]; // Number symbols (. decimal, , grouping)
hybridLocale[14] = localeEn[14]; // Number format patterns (¤ before amount)

registerLocaleData(hybridLocale, 'it-US', localeItExtra);
registerLocaleData(localeIt);
registerLocaleData(localeEn);
registerLocaleData(localeEnHk);

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
    .catch((err) => console.error(err));

